// Where a notification leads when clicked - shared by the bell dropdown, the Notifications page and the pop-ups
// (NotificationPopups.jsx), so the three can't drift apart again.
import { eduRoute } from '../edu/notifyRoutes';

const stock = (n) => `/app/stocks/${n.ticker}`;
// Duel notifications: ticker carries the duel's invite_code, not duel_id - /duel/:inviteCode handles every duel
// status gracefully (a recipient who hasn't accepted yet has no role on the duel, so /duels/{id}/live 403s).
const duel = (n) => (n.ticker ? `/duel/${n.ticker}` : null);

const ROUTE_BY_RULE_TYPE = {
  rsi_cross: stock,
  sma_cross: stock,
  pct_move: stock,
  price_target: stock,
  week52_proximity: stock,
  position_pnl: stock,
  concentration: stock,
  rrg_quadrant: (n) => `/app/sector/${n.ticker}`,
  sector_scanner: (n) => (n.rule_params && n.rule_params.sector)
    ? `/app/stock-scanner?sector=${encodeURIComponent(n.rule_params.sector)}` : null,
  playbook_performance: (n) => (n.rule_params && n.rule_params.playbook_id)
    ? `/app/playbook?id=${n.rule_params.playbook_id}` : null,
  portfolio_drawdown: () => '/app/portfolios',
  losing_streak: () => '/app/trades',
  pnl_record: () => '/app/trades',
  vix_zone: () => '/app/market-overview?tab=7',
  yield_curve: () => '/app/market-overview?tab=4',
  duel_invite: duel,
  duel_rematch: duel,
  duel_accepted: duel,
  duel_complete: duel,
  // backend/routine_reminders.py - ticker carries the session id; the Dashboard opens that session's routine.
  routine_wrapup: (n) => `/app?routine=${n.ticker || 'ny'}`,
  // backend/script_alerts.py - a Nova script's notify() (chart open) or a server-side script alert; ticker = symbol.
  script_alert: (n) => (n.ticker ? `/app/charting?symbol=${encodeURIComponent(n.ticker)}` : '/app/charting'),
};

/** The page a notification opens, or null when it has nowhere to go. */
export function routeForNotification(n) {
  if (n.scope === 'admin') return '/app/superadmin';
  const edu = eduRoute(n); // Academy: opens the class, thread or item it's about
  if (edu) return edu;
  const mapper = n.rule_type && ROUTE_BY_RULE_TYPE[n.rule_type];
  const route = mapper ? mapper(n) : null;
  if (route) return route;
  if (n.ticker) return stock(n);
  return null;
}

/** Fired after a notification is read somewhere, so the bell refreshes its badge right away. */
export const NOTIFICATIONS_CHANGED = 'nm-notifications-changed';
